<template>
  <div>
    <div> 
      <p class="title-company is-5">Dados da Empresa</p>
      <div class="columns">
        <div class="column is-4">
          <p class="is-5">Nome do solicitante <b class="required">*</b></p>
          <sc-field
              class="field-company"
              :message="(!value.client_name && checkFields) ? 'O campo é obrigatório.' : ''"
              :type="(!value.client_name && checkFields) ? 'is-danger' : ''">
            <sc-input 
              placeholder="Nome do solicitante"
              v-model="value.client_name"
              type="text">
            </sc-input>
          </sc-field>
        </div>
        <div class="column is-4">
          <p class="is-5">Telefone do solicitante <b class="required">*</b></p>
          <sc-field 
            class="field-company"
            :message="(!value.client_phone_number && checkFields) ? 'O campo é obrigatório.' : ''"
            :type="(!value.client_phone_number && checkFields) ? 'is-danger' : ''">
            <sc-input 
              placeholder="(DDD + Telefone + Ramal)"
              v-model="value.client_phone_number"
              type="text">
            </sc-input>
          </sc-field>
        </div>
        <div class="column is-4">
          <p class="is-5">E-mail do solicitante <b class="required">*</b></p>
          <sc-field 
            class="field-company"
            :message="(!value.client_email && checkFields) ? 'O campo é obrigatório.' : ''"
            :type="(!value.client_email && checkFields) ? 'is-danger' : ''">
            <sc-input 
              placeholder="E-mail corporativo"
              v-model="value.client_email"
              type="email"
              name="client_email">
            </sc-input>
          </sc-field>
        </div>
      </div>
      <hr>
      <div class="columns">
        <div class="column is-6">
          <p class="is-5">Informe os CNPJs dos centros de distribuição de sua operação <b class="required">*</b></p>
          <sc-field
            class="field-company"
            :message="(value.warehouses.length === 0 && checkFields) ? 'O campo é obrigatório.' : ''"
            :type="(value.warehouses.length === 0 && checkFields) ? 'is-danger' : ''">
              <sc-multiple-warehouse-search
                v-model="value.warehouses"
                :options="warehouses"
                @selectAll="values => handleSelectAll(values)"
                @clearFilterSelected="handleClearFilter"
                class="multiple-select"/>
          </sc-field>
        </div>
        <div class="column is-6">
          <p class="is-5">Número de contrato ou OS transportador <b class="required">*</b></p>
          <sc-field 
            class="field-company"
            :message="(!value.contract_number && checkFields) ? 'O campo é obrigatório.' : ''"
            :type="(!value.contract_number && checkFields) ? 'is-danger' : ''">
            <sc-input
              placeholder="Número de contrato ou OS transportador"
              v-model="value.contract_number"
              type="text">
            </sc-input>
          </sc-field>
        </div>
      </div>
      <hr>
      <div class="columns">
        <div class="column is-12">
          <sc-field 
            label="Outros comentários relevantes" 
            class="field-company">
            <sc-input 
              v-model="value.additional_information"
              placeholder="Adicione comentários relevantes ou informações específicas da integração."
              type="textarea">
            </sc-input>
          </sc-field>
        </div>
      </div>

      <sc-field 
        class="term"
        :message="(!value.has_contract && checkFields) ? 'O campo é obrigatório.' : ''"
        :type="(!value.has_contract && checkFields) ? 'is-danger' : ''">
        <sc-checkbox 
          v-model="value.has_contract" 
          class="term-check">
          Confirmo que essa integração está acordada e com contrato finalizado com o transportador escolhido.
        </sc-checkbox>
      </sc-field>
      <div>
        <new-quote-table-form 
          v-model="value.quote_table">
        </new-quote-table-form>
      </div>
      <div>
        <sc-field 
          class="term term-align"
          :message="(!value.client_consent && checkFields) ? 'O campo é obrigatório.' : ''"
          :type="(!value.client_consent && checkFields) ? 'is-danger' : ''">
          <sc-checkbox 
            v-model="value.client_consent"
            class="term-check">
            Li e concordo com os  <a class="term-text" @click="openModal">termos e condições</a>
          </sc-checkbox>
        </sc-field>
        <sc-term-modal :modal-active="modal" @close="closeModal"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScInput,
    ScField,
    ScButton,
    ScCheckbox,
    ScMultipleWarehouseSearch,
  } from '@intelipost-js/secure-components';

  import ScTermModal from '../../logistic-provider-form/components/ScTermModal/ScTermModal.vue';
  import NewQuoteTableForm from '../../add-delivery-method/NewQuoteTableForm.vue';

  const { mapState, mapActions, mapMutations } = createNamespacedHelpers(
    'integrations/integrationsAppSelfService',
  );

  export default {
    name: 'sc-freight-form',
  
    props: {
      value: {
        type: Object,
      },
      checkFields: {
        type: Boolean,
      },
    },

    data() {
      return {
      };
    },
    computed: {
      ...mapState([
        'warehouses',
        'modal',
        'clientInfo',
        'appDetails',
        'contact',
      ]),
    },
    methods: {
      ...mapActions([
        'getWarehouses',
        'getClientInfo',
      ]),
      ...mapMutations(['setModal']),

      handleSelectAll(values) {
        const varFields = this.value;
        varFields.warehouses = values;
      },
      handleClearFilter() {
        const varFields = this.value;
        varFields.warehouses.length = 0;
      },
      openModal() {
        this.setModal(true);
      },
      closeModal() {
        this.setModal(false);
      },
    },
    mounted() {
      this.getWarehouses();
      this.getClientInfo();
    },
    components: {
      ScInput,
      ScField,
      ScButton,
      ScMultipleWarehouseSearch,
      ScCheckbox,
      ScTermModal,
      NewQuoteTableForm,
    },
  };

</script>




// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/freight/ScFreightForm.vue